<template>
    <div
        class="mb-2"
        v-bind:class="{ 'mt-4': !recordingRequests.length && !allowRequest() }"
    >
        <v-btn
            v-if="allowRequest() && !requesting"
            small
            color="success"
            class="mb-4"
            :loading="procssing"
            @click="requestRecording()"
            >Request Recording</v-btn
        >
        <div v-if="requesting" style="width: 200px;">
            <v-text-field
                label="Email"
                v-model="email"
                :rules="emailRules"
                ref="email"
            ></v-text-field>
            <v-card-actions class="ml-0 mb-3">
                <v-btn
                    small
                    dark
                    color="default"
                    @click="cancelRequestRecording"
                    >Cancel</v-btn
                >
                <v-btn small color="success" @click="submitRequest"
                    >Submit Request</v-btn
                >
            </v-card-actions>
        </div>
        <div v-if="isRequested()" class="text-info mb-2 pb-2 ml-2">
            Recording Requested
        </div>
        <div
            v-if="recordingRequests.length"
            class="mb-5 px-1 pb-2"
            style="width: 600px; border: 2px solid #43a047;"
        >
            <div class="title font-weight-medium mb-3 py-1">
                Recording Requests
            </div>
            <div class="mb-2 font-weight-medium mx-3">
                <div class="layout row py-2">
                    <div class="mr-1 width-250">
                        Date
                    </div>
                    <div class="width-200">User</div>
                    <div class="">Sent</div>
                </div>
            </div>
            <div
                class="mb-2 mx-3"
                v-for="(request, index) in recordingRequests"
            >
                <div class="layout row pa-2" style="border: 1px solid black;">
                    <div class="mr-1 width-250">
                        {{ request.date | time }}
                    </div>
                    <div class="width-200">{{ request.byUser }}</div>
                    <div class="">{{ request.sent ? "Yes" : "No" }}</div>
                </div>
                <!-- <v-divider
                    class="py-2 mb-1"
                    v-if="index + 1 < recordingRequests.length"
                ></v-divider> -->
            </div>
        </div>
        <div
            class="dinner-ivr-detail-text mt-2 ml-3"
            v-if="details"
            v-for="(detail, index) in details"
        >
            <div class="layout row">
                <div class="mr-1  width-250">
                    {{ detail.date }}
                </div>
                <div class="">{{ detail.eventType }}</div>
            </div>
            <div class="layout row wrap mb-1 text--disabled">
                <div v-if="detail.inputDigits">
                    {{ detail.inputDigits }}
                </div>
                <div v-if="detail.response" class="px-1">
                    |
                </div>
                <div v-if="detail.eventType != 'START_PAYMENT_PROCESS'">
                    {{ detail.response }}
                </div>
            </div>
            <v-divider
                class="py-2 mb-1"
                v-if="index + 1 < details.length"
            ></v-divider>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            details: [],
            recordingRequests: [],
            procssing: false,
            requesting: false,
            email: "",

            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],

            callActionsMap: new Map([
                ["EnterPhone", "Prompt Enter Phone"],
                ["EnterPin", "Phone Entered - Prompt Enter Pin"],
                //["LoadStudent", "Pin Entered - Play Student Details"],
                ["ConnectCall", "Connect Call"],
                ["MenuOptions", "Menu Option"],
                ["PLAY_PRIZE_MESSAGE", "Play Prize Message"],
                ["PLAY_TRACKING_INFO", "Play Tracking Info"],
                ["CHECK_AMOUNT_INPUT", "Check Amount Input"],
                ["CHECK_DONATIONS_LINE_INPUT", "Check Amount Input"],
                ["CHECK_DONATIONS_LINE_AMOUNT_INPUT", "Check Amount Input"],
                ["CHECK_SCHEDULE_AMOUNT_INPUT", "Check Schedule Amount Input"],
                ["CHECK_SCHEDULE_COUNT_INPUT", "Check Schedule Count Input"],
                ["START_PAYMENT_PROCESS", "Start Payment Process"],
                ["START_AUTOPAYSETUP_PROCESS", "Start Auto Pay Setup Process"],
                ["PAYMENT_PROCESSING", "Payment Procssing"],
                ["CARD_PROCESSED_SUCCESS", "Payment Processed Successfully"],
                ["CARD_PROCESSED_FAILED", "Payment Failed"],
                ["AUTOPAY_SETUP_FAILED", "Auto Pay Setup Failed"],
                ["AUTOPAYSETUP_SUCCESS", "Auto Pay Setup Successfull"],
                ["CONTACT_US", "Contact Us"],
            ]),
        };
    },
    async created() {
        await this.loadDetails();
    },
    computed: {},
    methods: {
        async loadDetails() {
            const id = this.row.parentCallSid
                ? this.row.parentCallSid
                : this.row.callUUID
                ? this.row.callUUID
                : this.row.callSid;

            const response = await this.$http.get(
                "api/campCalls/getDetails?callUUID=" + id
            );

            this.details = response.details.map((detail) => {
                detail.date = moment(detail.date).format(
                    "MM/DD/YYYY h:mm:ss A"
                );

                detail.eventType =
                    this.callActionsMap.get(detail.eventType) ||
                    detail.eventType;

                if (detail.eventType == "LoadStudent") {
                    detail.eventType = detail.inputDigits
                        ? "Pin Entered - Play Student Details"
                        : "Play Student Details";
                }

                return detail;
            });

            this.recordingRequests = response.recordingRequests;
        },
        toEstTime(date) {
            return moment(date)
                .subtract(4, "hours")
                .format("MM/DD/YYYY h:mm:ss A");
        },
        requestRecording() {
            this.requesting = true;
            this.email = this.$store.state.authentication.user;
        },
        cancelRequestRecording() {
            this.requesting = false;
        },
        async submitRequest() {
            if (!this.$refs.email.validate(true)) return;

            try {
                this.procssing = true;

                const today = moment().format("YYYY-MM-DD HH:mm:ss");

                const id = this.row.parentCallSid
                    ? this.row.parentCallSid
                    : this.row.callUUID
                    ? this.row.callUUID
                    : this.row.callSid;

                await this.$http.post("api/campCalls/saveRecrdingRequest", {
                    callSid: id,
                    date: today,
                    byUser: this.$store.state.authentication.user,
                    email: this.email,
                });

                this.procssing = false;
                this.requesting = false;

                this.loadDetails();
            } catch (e) {
                this.procssing = false;
            }
        },
        allowRequest() {
            return !this.isRequested() && this.row.recording;
        },
        isRequested() {
            return this.recordingRequests.find(
                (r) =>
                    r.byUser == this.$store.state.authentication.user && !r.sent
            );
        },
    },
};
</script>
<style>
.dinner-ivr-detail-text {
    font-size: 16px;
    font-weight: 400;
}
</style>
